<template>
<UModal v-model="isOpen">
  <div class="relative">
    <div class="absolute -top-3 -right-3 bg-white rounded-full h-10 cursor-pointer" @click="isOpen = false">
      <UIcon name="i-ph-x-circle" class="w-10 h-10 bg-primeval-700"/>
    </div>
    <div class="">
      <NuxtLink :to="targetURL">
        <NuxtImg :src="sourceURL" class="object-contain w-full" alt="Flash card image" title="Flash card"/>
      </NuxtLink>
    </div>
  </div>
</UModal>
</template>

<script setup>
const isOpen = ref(true);
const props = defineProps(['items']);

const firstItem = props.banners.items && props.banners.items.length ? props.banners.items[0] : null;
const sourceURL = firstItem?.content.source || 'https://placehold.co/240x240';
const targetURL = firstItem?.action.target || '/';
</script>